import React, { useEffect, useState } from 'react';
import { InlineTextButton } from '../../../components';
import { getExpressUser } from '../../../services/user';
import css from './BuyWineDirect.module.css';
import WineCard from './WineCard/WindeCard';

const BuyWineDirect = ({
  wines,
  currentUser,
  winery,
  winesLoading,
  intl
}) => {
  const [limit, setLimit] = useState(6);
  const [user, setUser] = useState({})

  const isShipping = winery?.shippingStates !== undefined && winery?.shippingStates.includes(user && user.state)

  useEffect(() => {
    if(currentUser){
      getUser(currentUser?.expresUserId);
    }
  }, [currentUser]);
  const getUser = async (userId) => {
    const user = await getExpressUser(userId);
    setUser(user)
  }



  return (
    <div className={css.buyWineDirectWrapper}>
      <div className={css.buyWineDirectContainer}>
        <div className={css.buyWineDirectInfo}>
          <h1>Buy Wine Direct</h1>
          {currentUser === null ? (
            <p>Please login to see if this winery ships to your state!</p>
          ) : (
            <>
            {isShipping ? (
              <p>This winery ships to your state!</p>
            ) : (
              <p>This winery doesn't ship to your state!</p>
            )}
            </>
          )}

        </div>
        <div className={css.buyWineDirectWineCartContainer}>
          {wines.sort().slice(0, limit).map((wine,index) => (
            <WineCard wine={wine} intl={intl} />
          ))}
        </div>
        {wines && wines.length > limit ? (
          <div className={css.buyWineDirectBtnWrapper}>
            <InlineTextButton
              rootClassName={css.buyWineDirectLoadMoreBtn}
              onClick={() => setLimit(prev => prev + 6)}
            >
              Load More
            </InlineTextButton>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default BuyWineDirect
